import { render, staticRenderFns } from "./BaseTabsModule.vue?vue&type=template&id=04e8f208&scoped=true&"
import script from "./BaseTabsModule.vue?vue&type=script&lang=js&"
export * from "./BaseTabsModule.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabsModule.vue?vue&type=style&index=0&id=04e8f208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e8f208",
  null
  
)

export default component.exports